import React, { createContext, FC, useContext } from "react";
import type { IScope } from "../reducers/scope";
import type me from "../models/me";
import type app from "../lib/app";

export interface AppContext {
    app: typeof app;
    me: typeof me;
    scope: IScope;
}

const appContext = createContext<AppContext>({ app: null, me: null, scope: null });

export const AppProvider: FC<AppContext> = ({ app, me, scope, children }) => {
    const { Provider } = appContext;

    return <Provider value={{ app, me, scope }}>{children}</Provider>;
};

/**
 * Provides a preferable way to access singleton objects `app`, `me`, and `scope`.
 * Replaces the legacy context thingy for function components.
 */
export const useApp = (): AppContext => {
    return useContext(appContext);
};
